exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b15ca192] .v-datatable.v-table>tbody{max-height:none!important;min-height:0!important;overflow:hidden!important}[data-v-b15ca192] .v-icon{width:100%}", ""]);

// exports
